import { OpenInFull, SaveAlt } from '@mui/icons-material';
import { Box, IconButton, Paper } from '@mui/material';

import ExportChartButton from '@/components/Chart/ExportChartButton';
import Loader from '@/components/Loader';
import Tabs from '@/components/Tabs';
import { PageInformationContext } from '@/context/PageInformationContext';
import { useAppSelector } from '@/hooks/redux-hooks';
import SummaryChart from '@/pages/DataHub/Chart/SummaryChart';

import DataHubPreview from './Preview';
import DataHubStats from './Stats';

const pageInformation = {
  mainPageTitle: 'Data Hub'
};
const DataHubSummary = ({ navigateToDataHub }: { navigateToDataHub: (index: number) => void }) => {
  const { loading } = useAppSelector(state => state.dhData);
  const { status } = useAppSelector(state => state.dataHub);
  const isDataHubLoading = status === 'loading';

  if (isDataHubLoading)
    return (
      <Box sx={{ flex: 1 }}>
        <Loader />
      </Box>
    );
  return (
    <PageInformationContext.Provider value={pageInformation}>
      <Box sx={{ display: 'flex', position: 'relative', flex: 1, gap: 2, pt: 2 }}>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <DataHubStats />
          <Paper
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'relative'
            }}
          >
            <Box sx={{ display: 'flex', flex: 1, justifyContent: 'space-between' }}>
              <Tabs
                activeTab={0}
                tabs={[{ name: 'Recently added' }]}
              />
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <ExportChartButton
                  disabled={loading}
                  tabName='Recently added'
                />

                <IconButton
                  disabled={loading}
                  sx={{
                    width: 30,
                    height: 48,
                    p: 0,
                    minWidth: 30,
                    borderRadius: 0,
                    backgroundColor: 'secondary.main'
                  }}
                  onClick={() => {
                    navigateToDataHub(2);
                  }}
                >
                  <OpenInFull sx={{ fontSize: 14 }} />
                </IconButton>
              </Box>
            </Box>
          </Paper>
          <SummaryChart />
        </Box>
        <Paper
          sx={{
            flex: 1,
            overflowX: 'auto',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Tabs
              activeTab={0}
              tabs={[{ name: 'All Data Hub items' }]}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
              <IconButton
                disabled={loading}
                sx={{
                  width: 30,
                  height: 48,
                  p: 0,
                  minWidth: 30,
                  borderRadius: 0,
                  backgroundColor: 'secondary.main'
                }}
                onClick={() => {
                  navigateToDataHub(3);
                }}
              >
                <SaveAlt sx={{ fontSize: 16 }} />
              </IconButton>
              <IconButton
                disabled={loading}
                sx={{
                  width: 30,
                  height: 48,
                  p: 0,
                  minWidth: 30,
                  borderRadius: 0,
                  backgroundColor: 'secondary.main'
                }}
                onClick={() => {
                  navigateToDataHub(1);
                }}
              >
                <OpenInFull sx={{ fontSize: 14 }} />
              </IconButton>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flex: 1 }}>
            <DataHubPreview isSummary />
          </Box>
        </Paper>
      </Box>
    </PageInformationContext.Provider>
  );
};

export default DataHubSummary;
